const images = {
  backgroundImage: require("./img/Illustration.png"),
  qrCode: require("./img/qrCode.png"),
  tiqconnectLogo: require("./img/new_logo.png"),
  userGuideLogo: require("./img/library_books-24px.png"),
  contactUsLogo: require("./img/call-24px.png"),
  passwordLogo: require("./img/password_icon.png"),
  facebookLogo: require("./img/facebook (4)@3x.png"),
  linkedInLogo: require("./img/linkedin@3x.png"),
  youtubeLogo: require("./img/youtube@3x.png"),
  enterPolicyNoLogo: require("./img/details.png"),
  checkCoverageLogo: require("./img/verify.png"),
  creditCardLogo: require("./img/card.png"),
  customerCareLogo: require("./img/customer-care.png"),
  connectorLogo: require("./img/group.png"),
  connectorVerticalLogo: require("./img/group-vertical.png"),
  etiqaLogo: require("./img/etiqa_logo.png"),
  hLogo: require("./img/group-24px_active.png"),
  sLogo: require("./img/share-24px.png"),
  renewalHeader: require("./img/desktoplogoWhite.png"),
  accountExist:require("./img/account.png"),
  successful: require("./img/success.png"),
  successfulLogin: require("./img/successful.png"),
  failureIcon: require("./img/failV2.png"),
  dbsLogo:require("./img/dbs.png"),
  directClientEtiqaLogo:require("./img/etiqa_logo_BNDC.png"),
  nonDirectClientEtiqaLogo:require("./img/etiqa_logo_NDC.png"),
  directClientEtiqaLogoNew:require("./img/etiqaLogoChanged.png"),
  nonDirectClientBG:require("./img/imgBgEtiqa.jpg"),
  bgEtiqaNew:require("./img/bgEtiqaNew.png"),
  bgEtiqaNewH:require("./img/bgEtiqaNewV3.png"),
  renewalBanner:require("./img/renewalBanner.jpg"),
  enrolGiroBg:require("./img/enrolGiroBackground2.png"),
  clear_icon:require("./img/shape.png"),
  download_icon:require("./img/download.png"),
  otp_icon:require("./img/otp.png"),
  deleteAttachFileIcon: require("./img/delete.png"),
  uploadAttachFileIcon: require("./img/upload.png"),
  uploadAttachFileIconHover: require("./img/dragNDropHover.png"),
  whiteBin: require("./img/binWhite.png"),
  eGiroLogo: require("./img/eGiroLogo.png"),
  cyber: require("./img/cyber.jpg"),
  etiqaLogoDesktop: require("./img/etiqaLogoDesktop.png"),

  liveGeneral: require("./img/general.png"),
  liveHomeFire: require("./img/home_fire.png"),
  liveMaid: require("./img/maid.png"),
  liveMotor: require("./img/motor.png"),
  liveSavings: require("./img/savings.png"),
  liveChatBtn: require("./img/liveChatButton.png"),
  liveChatChatBot: require("./img/chatBotProfilePic.png"),
  chatBot: require("./img/chatbot.png"),
  clearWhite: require("./img/clearWhite.png"),
  navigateGigantiq: require("./img/navigateGigantiq.png"),
  upDownIcon: require("./img/updown.png"),
  scheduleApp: require("./img/scheduleApp.svg"),
  maleAgent: require("./img/maleAgent.png"),
  testingImg:require("./img/testingImg.jpg"),

  movieImg:require("./img/movieImg02.png"),
  movieImgV2:require("./img/movieBG.png"),
  plus:require("./img/plus.png"),
  plusB:require("./img/plusb.png"),
  creditCardL:require("./img/credit_card.png"),
  singpassBtn:require("./img/singpassbtnNew.svg"),
  phoneIcon:require("./img/phoneIcon.png"),
  dDebit:require("./img/directDebitIcon.png"),
  etiqaLogoCouponCode: require("./img/etiqaInsuranceLogi.png"),

  good1: require("./img/good-1.svg"),
  good2: require("./img/good-2.svg"),
  bad1: require("./img/bad-1.svg"),
  bad2: require("./img/bad-2.svg"),

  walkAndWagBottomBackground: require("./img/WalkAndWag/BottomBackground.png"),
  walkAndWagBundleDeals: require("./img/WalkAndWag/BundleDeals.svg"),
  walkAndWagPaymentFail: require("./img/WalkAndWag/PaymentFail.png"),
  walkAndWagPaymentSuccess: require("./img/WalkAndWag/PaymentSuccess.png"),
  walkAndWagPinLocation: require("./img/WalkAndWag/PinLocation.svg"),
  walkAndWagMasterTitleHeader: require("./img/WalkAndWag/MasterTitleHeader.png"),
  walkAndWagChartSize: require("./img/WalkAndWag/ChartSize.png"),

  onboardingNewUser: require("./img/onboardingNewUser.png"),
  onboardingExisting: require("./img/onboardingExisting.png"),
  contSingpass: require("./img/continueSingpass.png"),
  redHint: require("./img/hintRed.png"),
  calender: require("./img/calenderIc.svg"),
  otpIcon: require("./img/OTP.svg"),
  xIcon: require("./img/x.svg"),
  goIcon: require("./img/goIcon.svg"),
  phoneIcon: require("./img/phone.svg"),
  chatIcon: require("./img/chat.svg"),
  celebrativeIcon: require("./img/Celebrative.svg"),
  wrongIcon: require("./img/wrongIcon.svg"),
  errorHint: require("./img/errorHint.svg"),
};

export default images;
